<template>
  <section role="region" class="want-know-more-section">
    <TheCard secondHeading="Quer saber mais sobre réguas de relacionamento?"
      fourthHeading="Confira nosso material exclusivo com informações detalhadas sobre como funcionam as réguas de comunicação e quais suas aplicações."
      buttonText="Baixar material gratuitamente"
      @buttonClicked="buttonClicked('https://materiais.simply.com.br/ebook-regua-de-relacionamento-digital')">
      <template #image-box>
        <ThePicture mobilePath="/images/business/m-regua.png"
          tabletPath="/images/business/t-regua.png" desktopPath="/images/business/regua.png"
          mobileQuerie="834px" desktopQuerie="960px" altText="Moça olhando para o celular na mão e sorrindo" />
      </template>
    </TheCard>
  </section>
</template>

<script setup lang="ts">

const buttonClicked = (path: string) => window.open(path, '_blank');
</script>

<style lang="scss">
.want-know-more-section {
  padding: 40px 20px;

  .default-card {
    background-color: #F6F6F6;
    box-shadow: none;
    padding: 20px;

    .text-box {
      h2 {
        font-size: 36px;
        line-height: 110%;
        margin: 20px 0px 16px;
      }
    }

    .default-button {
      margin-top: 16px;
      display: flex;
      width: 280px !important;
      padding: 15px 17px !important;
      justify-content: center;
      align-items: center;
    }
  }


  @media screen and (min-width: 834px) and (max-width: 959px) {
    padding: 69px 32px 68px;

    .default-card {
      padding: 32px;
      max-width: 896px;

      .text-box {
        h4 {
          width: 80%;
        }
      }

      .default-button {
        margin-top: 32px;
        width: 292px !important;
      }
    }
  }

  @media screen and (min-width: 960px) and (max-width: 1199px) {
    padding: 68px 30px 59px 30px;

    .default-card {
      padding: 50px 60px 49px;

      .text-box {
        width: 80%;
      }
    }
  }


  @media screen and (min-width: 834px) {
    .default-card {
      display: grid;
      grid-template-areas:
        "text-box image-box"
        "default-button image-box";
      justify-content: space-between;

      .image-component {
        grid-area: image-box;
      }

      .text-box {
        grid-area: text-box;
        text-align: start;

        h2 {
          font-size: 42px;
          margin: 0px 0px 16px;
        }
      }

      .default-button {
        grid-area: default-button;
      }
    }
  }

  @media screen and (min-width: 960px) {
    .default-card {
      margin: 0 auto;
      max-width: 970px;

      .default-button {
        width: 299px !important;
      }
    }
  }

  @media screen and (min-width: 1200px) {
    padding: 68px 0px;

    .default-card {
      padding: 50px 94px 49px 100px;

      .text-box {
        width: 82%;
        align-self: end;
      }

      .default-button {
        margin-top: 32px;
      }
    }
  }
}
</style>